<template>
  <nav class="pi-tabs" aria-label="Visões do Product Intelligence">
    <router-link v-for="view in views" :key="view.key" class="pi-tab" :class="{ 'is-on': current === view.key }"
                 :to="{ path: view.path, query: query }"
                 :aria-current="current === view.key ? 'page' : null">{{ view.label }}</router-link>
  </nav>
</template>

<script>
import { PI_VIEWS } from "./piNavigation.js";
import { PI_FILTER_DEFAULTS } from "./piQuery.js";

export default {
  name: "pi-tabs",
  props: {
    current: { type: String, default: "" },
  },
  computed: {
    views() {
      return PI_VIEWS;
    },
    query() {
      const source = (this.$route && this.$route.query) || {};
      const query = {};
      Object.keys(PI_FILTER_DEFAULTS).forEach((key) => {
        if (source[key]) query[key] = source[key];
      });
      return query;
    },
  },
};
</script>

<style scoped>
.pi-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  margin-bottom: 16px;
  overflow-x: auto;
  border-bottom: 1px solid #e6e7eb;
}

.pi-tab {
  flex: 0 0 auto;
  padding: 10px 14px;
  border-bottom: 2px solid transparent;
  font-size: 13px;
  font-weight: 600;
  color: #4e5560;
  text-decoration: none;
  white-space: nowrap;
}

.pi-tab:hover,
.pi-tab:focus {
  color: #1d12b9;
  text-decoration: none;
}

.pi-tab:focus {
  outline: 2px solid #1b59f8;
  outline-offset: -2px;
}

.pi-tab.is-on {
  color: #1d12b9;
  border-bottom-color: #1d12b9;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piTabs.vue